import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/** 4:3, the aspect ratio of the flag SVGs. */
const DEFAULT_FLAG_WIDTH_PX = 20;
const DEFAULT_FLAG_HEIGHT_PX = 15;

/** A country's flag from the shared set in libs/shared-assets/icons/flags (4:3 SVGs). */
@Component({
  selector: 'fr8bot-ui-flag-icon',
  host: { class: 'tw:inline-flex tw:shrink-0' },
  templateUrl: './flag-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagIconUIComponent {
  /** ISO 3166-1 alpha-2 code, in any case: `US`, `ca`. Without one nothing is drawn. */
  readonly country = input.required<string | undefined>();
  /** Defaults to the upper-case code. */
  readonly alt = input<string>();
  readonly width = input(DEFAULT_FLAG_WIDTH_PX);
  readonly height = input(DEFAULT_FLAG_HEIGHT_PX);

  protected readonly code = computed(() => this.country()?.toLowerCase());
  protected readonly label = computed(() => this.alt() || this.code()?.toUpperCase());
}
